import { Box, Column, Text } from '@atom-web/micros'
import Image from 'next/image'

import StyledLink from '../../../components/StyledLink'

const InterlinkingSmallCard = ({
	height,
	width,
	componentData,
	border = false,
	componentName,
	onEvent,
}) => {
	return (
		<StyledLink href={componentData?.slug || ''} onClick={onEvent}>
			<Column
				css={{
					width: width,
					paddingBottom: '10px',
				}}
			>
				<Box
					css={{
						height: height,
						width: width,
						borderRadius: '$4',
						overflow: 'hidden',
						position: 'relative',
						border: border ? 'solid 0.5px $grey12' : null,
						backgroundColor: '$primary00',
					}}
				>
					{componentData?.image ? (
						<Image
							src={componentData?.image}
							alt={componentData?.alt}
							layout="fixed"
							width={width}
							height={height}
							objectFit="cover"
						/>
					) : null}
				</Box>
				{componentData?.title ? (
					<Text
						css={{
							fontSize:
								componentName === 'widgets.slider-for-small-cards'
									? '$3'
									: '$4',
							lineHeight: '$2',
							color: '$grey12',
							fontWeight: '$bold',
							paddingTop: '$3',
						}}
					>
						{componentData?.title}
					</Text>
				) : null}
				{componentData?.description ? (
					<Text
						css={{
							fontSize: '$2',
							lineHeight: '$2',
							color: '$grey08',
							fontWeight: '$normal',
							paddingTop: '2px',
						}}
					>
						{componentData?.description}
					</Text>
				) : null}
			</Column>
		</StyledLink>
	)
}
export default InterlinkingSmallCard
